import { Instagram, Mail } from "lucide-react";
import { FOUNDERS, CONTACT_EMAIL, INSTAGRAM, LOGO_URL } from "@/lib/brand";

const LINKS = [["What's inside", "/#whats-inside"], ["Plans", "/#pricing"], ["Founders", "/#founders"], ["FAQ", "/#faq"]];
const names = FOUNDERS.map((f) => f.name);

export const Footer = () => (
  <footer className="border-t border-stone-200 bg-white" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-10 md:items-end">
      <div>
        <img src={LOGO_URL} alt="The Little Lantern Club" className="h-24 w-auto object-contain" />
        <p className="text-stone-600 mt-2 max-w-xs">A little light, delivered monthly. Shipping within India.</p>
      </div>
      <nav className="flex flex-wrap md:flex-col gap-x-6 gap-y-2 text-sm text-stone-700" data-testid="footer-nav">
        {LINKS.map(([l, h]) => <a key={h} href={h} className="hover:text-amber-700 transition-colors" data-testid={`footer-link-${h.slice(2)}`}>{l}</a>)}
      </nav>
      <div className="flex flex-col gap-3 text-stone-700 text-sm">
        <a href={`mailto:${CONTACT_EMAIL}`} className="flex items-center gap-2 hover:text-amber-700 transition-colors" data-testid="footer-email-link"><Mail className="h-4 w-4" />{CONTACT_EMAIL}</a>
        <a href={`https://instagram.com/${INSTAGRAM.slice(1)}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-amber-700 transition-colors" data-testid="footer-instagram-link"><Instagram className="h-4 w-4" />{INSTAGRAM}</a>
      </div>
    </div>
    <div className="border-t border-stone-100 px-6 py-6 text-center text-xs text-stone-500">
      © {new Date().getFullYear()} The Little Lantern Club · <span className="font-hand text-base text-stone-700" data-testid="footer-founders">made with care by {names.slice(0, -1).join(", ")} & {names[names.length - 1]}</span>
    </div>
  </footer>
);
